<div class="row">
    <div class="col-12 col-md-6">
        <h1 class="page-header "><i class="fas fa-chart-pie"></i> Resumen General
            @if(budgetFund?.length>1){ - Fondo
                @for(f of budgetFund; track f.id){ <small> <span class="badge bg-success me-1 mt-3">{{f.fundCode}}</span> </small> }
               }
        </h1>
    
    </div>
    <div class="col-12 mb-3 col-md-6">
        <div class=" d-md-flex fw-bold justify-content-end">
            <div class="mt-3">
                <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
                    @if(items?.revenues?.length>0){
                    <a href="javascript:;"
                        class="text-decoration-none text-dark text-opacity-75"
                        (click)="exportPDF()"><i
                            class="fa fa-print fa-fw me-1 text-dark text-opacity-50"></i> Imprimir</a>}
                </div>
            </div>
            <div class="mt-3">
                <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
                    @if(importAasinet?.length>0){
                    <a href="javascript:;" (click)="exportAasinetImport()"
                        class="text-decoration-none text-dark text-opacity-75"><i
                            class="fa fa-download fa-fw me-1 text-dark text-opacity-50" ></i> Exportar Aasinet</a>}

                </div>
            </div>
        </div>
    </div>
</div>


<app-budget-over-view [data]="items" [filterItemCode]="undefined" [departament]="undefined" [fundCode]="undefined"></app-budget-over-view>



@if(entitySelected?.group!='IASD'){
<div class="col-xl-12 mb-3 ">
    <!-- abre row align-items-stretch -->
    <div class="row">
        <div class="col-xl-8">
             <div class="row">
                <div class="col-xl-12">
                    <div class="panel h-100">

                        <div class="panel-body pb-0">
                            <div class="table-responsive table-data mt-2">
                              <table class="table table-sm table-hover">
                                <thead>
                                  <tr>
                                    <th style="width: 380px;">
                                      <h5><i class="fa fa-arrow-up text-success me-1"></i> Ingresos por Categoría</h5>
                                    </th>
                                    <th class="text-center text-muted"><h6>
                                      @if (items?.revenueTotals?.length > 0) {
                                        {{ ((getTotalRevenue(items?.revenueTotals)) * 100 / getTotalRevenue(items?.revenueTotals)) | number:'1.0-0' }}%
                                      }
                                      </h6>
                                    </th>
                                    <th class="text-end"><h5>
                                      @if (items?.revenueTotals?.length > 0) {
                                        $ {{ getTotalRevenue(items?.revenueTotals) | number:'1.0-0' }}
                                      }
                                      </h5>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="mb-3">
                                    @for (f of groupedAccounts; track f; let i = $index) {
                                        <tr>
                                          <td>{{ f?.accountParentCode }} - {{ capitalize(f?.accountParentName) }}</td>
                                          <td class="text-center text-muted">
                                            {{ f?.percent | number:'1.2-2' }} %
                                          </td>
                                          <td class="text-end fw-bold" [ngClass]="{ 'text-danger': f?.totalValue < 0 }">
                                            $ {{ f?.totalValue | number:'1.0-0' }}
                                          </td>
                                        </tr>
                                      }
                                      
                                </tbody>
                              </table>
                            </div>
                          </div>
                          
                    </div>
                </div>
                <div class="col-xl-12 mt-3">
                    <div class="panel h-100">

                        <div class="panel-body p-3">

                   
                            <div class="table-responsive table-data mt-2">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                          <th style="width: 380px;">
                                            <h5><i class="fa fa-arrow-down text-danger me-1"></i> Egresos por Categoría</h5>
                                          </th>
                                          <th class="text-center text-muted"><h6>
                                            @if (items?.expenseTotals?.length > 0) {
                                              {{ ((this.getTotalExpense(items?.expenseTotals)) * 100 / this.getTotalRevenue(items?.revenueTotals)) | number:'1.2-2' }}%
                                            }
                                            </h6>
                                          </th>
                                          <th class="text-end"><h5>
                                            @if (items?.revenueTotals?.length > 0) {
                                              $ {{ this.getTotalExpense(items?.expenseTotals) | number:'1.0-0' }}
                                            }
                                            </h5>
                                          </th>
                                        </tr>
                                      </thead>
                                    <tbody>
                                      @for (f of groupedExpenses; track f; let i = $index){
                                      <tr>
                                        <td >{{f?.code*10000}} - {{capitalize(f?.displayName)}}</td>
                                        <td class="text-center text-muted">{{f?.percent | number:'1.2-2'}} %    </td>
                                        <td class="text-end fw-bold" [ngClass]="{'text-danger': f?.totalValue < 0}">$ {{f?.totalValue | number:'1.0-0'}}</td>
                                    </tr>
                                      }
        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 mt-3">
                    <div class="panel h-100">

                        <div class="panel-body p-3">
                            <div class="table-responsive table-data mt-2">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                          <th style="width: 380px;">
                                            <h5><i class="fa fa-equals text-primary me-1"></i> Margen (Ingresos - Egresos)</h5>
                                          </th>
                                          <th class="text-center text-muted"><h6>
                                            @if (items?.expenseTotals?.length > 0) {
                                              {{ ((getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals)) * 100 / getTotalRevenue(items?.revenueTotals)) | number:'1.2-2' }}%
                                            }
                                            </h6>
                                          </th>
                                          <th class="text-end"><h5>
                                            @if (items?.expenseTotals?.length > 0) {
                                              $ {{ getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals) | number:'1.0-0' }}
                                            }
                                            </h5>
                                          </th>
                                        </tr>
                                      </thead>
                                    <tbody>
                                       <tr>
                                        <td>3000000 - Total Ingresos</td>
                                        <td class="text-center text-muted">
                                            @if(items?.revenueTotals?.length > 0){
                                            {{getTotalRevenue(items?.revenueTotals)*100/getTotalRevenue(items?.revenueTotals) | number:'1.2-2'}} %   } </td>
                                        <td class="text-end fw-bold" >$ @if(items?.revenueTotals?.length > 0){
                                            {{getTotalRevenue(items?.revenueTotals) | number:'1.0-0'}}
                                        }</td>
                                    </tr>
                                    <tr>
                                        <td>4000000 - Total Egresos</td>
                                        <td class="text-center text-muted">
                                            @if(items?.expenseTotals?.length > 0){
                                            {{getTotalExpense(items?.expenseTotals)*100/getTotalRevenue(items?.revenueTotals) | number:'1.2-2'}} %  
                                            }  </td>
                                        <td class="text-end fw-bold text-danger" >$ 
                                            @if(items?.expenseTotals?.length > 0){
                                            {{getTotalExpense(items?.expenseTotals) | number:'1.0-0'}}
                                            }</td>
                                    </tr>
        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        

        </div>
        <div class="col-xl-4 mt-xl-0 mt-md-3 mt-sm-3">
            
            <div class="card border-0 mb-3 h-100">
                <div class="card-body d-flex flex-column justify-content-between">
                    <div>
                        <h5>Proyección
                        </h5>
                    </div>
                    <div class="d-flex justify-content-center align-items-center flex-grow-1 h-150px">
                    <canvas baseChart  [type]="'doughnut'" [data]="doughnutChartData"
                        [options]="doughnutChartOptions" [plugins]="[ChartDataLabels]">
                    </canvas>
                    </div>
                    <div class="mt-3">
                        <h5>Ideal REA</h5>
                    </div>
                    <div  class="list-group list-group-flush mt-2 mb-1">
                        @for (f of factorRea; track f.id; let i = $index){
                            @if(f?.itemCode!=3){
                            <a class="list-group-item list-group-item-action d-flex">
                                <span class="flex-1">{{f.itemCode==500?capitalize(f?.displayName):f.itemCode+' - '+capitalize(f?.displayName)}}</span>
                                <span class="badge fs-10px w-40px" [ngClass]="f?.style">{{f?.value}}%</span>
                            </a>
                            }
                        }
                    </div>
                </div>

            </div>
        </div>



    </div>

    <!-- Cierra row align-items-stretch -->
</div>
}

@if(entitySelected?.group=='IASD'){
<div class="col-xl-12 mb-3 ">
    <!-- abre row align-items-stretch -->
    <div class="row">
        <div class="col-xl-8">
             <div class="row">
                <div class="col-xl-12">
                    <div class="panel h-100">

                        <div class="panel-body pb-0">
                            <div class="table-responsive table-data mt-2">
                              <table class="table table-sm table-hover">
                                <thead>
                                  <tr>
                                    <th style="width: 380px;">
                                      <h5><i class="fa fa-arrow-up text-success me-1"></i> Ingresos por Categoría</h5>
                                    </th>
                                    <th class="text-center text-muted"><h6>
                                      @if (items?.revenueTotals?.length > 0) {
                                        {{ ((getTotalRevenue(items?.revenueTotals)) * 100 / getTotalRevenue(items?.revenueTotals)) | number:'1.0-0' }}%
                                      }
                                      </h6>
                                    </th>
                                    <th class="text-end"><h5>
                                      @if (items?.revenueTotals?.length > 0) {
                                        $ {{ getTotalRevenue(items?.revenueTotals) | number:'1.0-0' }}
                                      }
                                      </h5>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="mb-3">
                                    @for (f of groupedAccounts; track f; let i = $index) {
                                        <tr>
                                          <td>{{ f?.accountParentCode }} - {{ capitalize(f?.accountParentName) }}</td>
                                          <td class="text-center text-muted">
                                            {{ f?.percent | number:'1.2-2' }} %
                                          </td>
                                          <td class="text-end fw-bold" [ngClass]="{ 'text-danger': f?.totalValue < 0 }">
                                            $ {{ f?.totalValue | number:'1.0-0' }}
                                          </td>
                                        </tr>
                                      }
                                      
                                </tbody>
                              </table>
                            </div>
                          </div>
                          
                    </div>
                </div>
                <div class="col-xl-12 mt-3">
                    <div class="panel h-100">

                        <div class="panel-body p-3">

                   
                            <div class="table-responsive table-data mt-2">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                          <th style="width: 380px;">
                                            <h5><i class="fa fa-arrow-down text-danger me-1"></i> Egresos por Categoría</h5>
                                          </th>
                                          <th class="text-center text-muted" >
                                          </th>
                                          <th class="text-end"><h5>
                                            @if (items?.revenueTotals?.length > 0) {
                                              $ {{ this.getTotalExpense(items?.expenseTotals) | number:'1.0-0' }}
                                            }
                                            </h5>
                                          </th>
                                        </tr>
                                      </thead>
                                    <tbody>
                                      @for (f of groupedExpenses; track f; let i = $index){
                                      <tr>
                                        <td >{{f?.code*10000}} - {{capitalize(f?.displayName)}}</td>
                                        <td class="text-center text-muted">
                                          <h6 ngbTooltip="Sobre Ingresos Diezmo: $ {{this.findTitheTotal() | number:'1.0-0'}}" placement="top" [container]="body">{{f?.percent | number:'1.2-2'}} %    </h6>
                                        </td>
                                        <td class="text-end fw-bold" [ngClass]="{'text-danger': f?.totalValue < 0}">$ {{f?.totalValue | number:'1.0-0'}}</td>
                                    </tr>
                                      }
        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 mt-3">
                    <div class="panel h-100">

                        <div class="panel-body p-3">
                            <div class="table-responsive table-data mt-2">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                          <th style="width: 380px;">
                                            <h5><i class="fa fa-equals text-primary me-1"></i> Margen (Ingresos - Egresos)</h5>
                                          </th>
                                          <th class="text-center text-muted">
                                            <h6 ngbTooltip="Sobre Ingresos Diezmo: $ {{(this.findTitheTotal() | number:'1.0-0')}}" placement="top" [container]="body">
                                            @if (items?.expenseTotals?.length > 0) {
                                              {{ ((getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals)) * 100 / this.findTitheTotal()) | number:'1.2-2' }}%
                                            }
                                            </h6>
                                          </th>
                                          <th class="text-end"><h5>
                                            @if (items?.expenseTotals?.length > 0) {
                                              $ {{ getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals) | number:'1.0-0' }}
                                            }
                                            </h5>
                                          </th>
                                        </tr>
                                      </thead>
                                    <tbody>
                                       <tr>
                                        <td>3000000 - Total Ingresos</td>
                                        <td class="text-center text-muted">
                                        </td>
                                        <td class="text-end fw-bold"  >$ @if(items?.revenueTotals?.length > 0){
                                            {{getTotalRevenue(items?.revenueTotals) | number:'1.0-0'}}
                                        }</td>
                                    </tr>
                                    <tr>
                                        <td>4000000 - Total Egresos</td>
                                        <td class="text-center text-muted"></td>
                                        <td class="text-end fw-bold text-danger" >$ 
                                            @if(items?.expenseTotals?.length > 0){
                                            {{getTotalExpense(items?.expenseTotals) | number:'1.0-0'}}
                                            }</td>
                                    </tr>
        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        

        </div>
        <div class="col-xl-4 mt-xl-0 mt-md-3 mt-sm-3">
            
            <div class="card border-0 mb-3 h-100">
                <div class="card-body d-flex flex-column justify-content-between">
                    <div>
                        <h5>Proyección
                        </h5>
                    </div>
                    <div class="d-flex justify-content-center align-items-center flex-grow-1 h-150px">
                    <canvas baseChart  [type]="'doughnut'" [data]="doughnutChartData"
                        [options]="doughnutChartOptions" [plugins]="[ChartDataLabels]">
                    </canvas>
                    </div>
                    <div class="mt-3">
                        <h5>Ideal REA (Sobre Ingresos Diezmo)</h5>
                    </div>
                    <div  class="list-group list-group-flush mt-2 mb-1">
                        @for (f of factorRea; track f.id; let i = $index){
                            @if(f?.itemCode!=3){
                            <a class="list-group-item list-group-item-action d-flex">
                                <span class="flex-1">{{f.itemCode==500?capitalize(f?.displayName):f.itemCode+' - '+capitalize(f?.displayName)}}</span>
                                <span class="badge fs-10px w-40px" [ngClass]="f?.style">{{f?.value}}%</span>
                            </a>
                            }
                        }
                    </div>
                </div>

            </div>
        </div>



    </div>

    <!-- Cierra row align-items-stretch -->
</div>
}

@if(entitySelected?.group=='IASD'&&factorRea?.length>0){
<div class="hide">
    <table class="table " id="table-revenue">
        <thead>
            <tr>
                <th colspan="6">
                    <h5><i class="fa fa-arrow-up text-success me-1"></i> Ingresos por Categoría</h5>
                </th>
            </tr>
            <tr>
                <th style="width: 380px;">Descripción</th>
                <th>% REA</th>
                <th>% Resultado</th>
               @if(entitySelected?.group=='IASD'){
                @for (item of items?.revenuesDepartaments; track i+item.code; let i = $index){
                    <th class="text-end">{{item.departamentDisplayName}}</th>
                    }
                    }
                <th>Total</th>
            </tr>
        </thead>
        <tbody>
            @for (f of groupedAccounts; track f; let i = $index) {
            <tr>
                <td>{{ f?.accountParentCode }} - {{ capitalize(f?.accountParentName) }}</td>
                <td class="text-center text-muted">

                </td>
                <td class="text-center text-muted">
                    {{ f?.percent | number:'1.2-2' }} %
                </td>
                @if(entitySelected?.group=='IASD'){
                @for (item of items?.revenuesDepartaments; track i+item.code; let i = $index){
                    <td class="text-end">{{getValueRevenueDepartamentFund( f?.accountParentCode,item.departamentCode) | number:'1.0-0'}}</td>
                    }
                }
                <td class="text-end fw-bold" [ngClass]="{ 'text-danger': f?.totalValue < 0 }">
                    $ {{ f?.totalValue | number:'1.0-0' }}
                </td>
            </tr>
            }

        </tbody>
        <tfoot>
            <tr>
                <td class="fw-bold">
                    Total Ingresos
                </td>
                <td class="text-center text-muted"></td>
                <td class="text-center text-muted">
                    @if (items?.revenueTotals?.length > 0) {
                    {{ ((getTotalRevenue(items?.revenueTotals)) * 100 /
                    getTotalRevenue(items?.revenueTotals)) | number:'1.0-0' }}%
                    }
                </td>
                @if(entitySelected?.group=='IASD'){
                @for (item of items?.revenuesDepartaments; track i+item.code; let i = $index){
                    <td class="text-end">{{item.totalValue | number:'1.0-0'}}</td>
                    }
                }
                <td class="text-end">
                    @if (items?.revenueTotals?.length > 0) {
                    $ {{ getTotalRevenue(items?.revenueTotals) | number:'1.0-0' }}
                    }
                </td>
            </tr>
        </tfoot>
    </table>


    <table class="table " id="table-expense">
        <thead>
            <tr>
                <th colspan="6" style="width: 380px;">
                    <h5><i class="fa fa-arrow-down text-danger me-1"></i> Egresos por Categoría</h5>
                </th>

            </tr>
        </thead>
        <tbody>
            @for (f of groupedExpensesDepartamentFund; track f; let i = $index){
            <tr>
                <td>{{f?.code*10000}} - {{capitalize(f?.displayName)}}</td>
                <td class="text-center text-muted">{{findFactorRea(f?.code)?.value | number:'1.2-2'}} % </td>
                <td class="text-center text-muted">{{f?.percent | number:'1.2-2'}} % </td>
                @if(entitySelected?.group=='IASD'){
                @for (item of items?.revenuesDepartaments; track i+item.code; let i = $index){
                    <td class="text-end">{{getValueExpenseDepartamentFund( f,item.departamentCode) | number:'1.0-0'}}</td>
                }
                }
                <td class="text-end fw-bold" [ngClass]="{'text-danger': f?.totalValue < 0}">$
                    {{f?.totalValue | number:'1.0-0'}}</td>
            </tr>
            }

        </tbody>
        <tfoot>
            <tr>
                <td class="fw-bold">
                    Total Egresos
                </td>
                <td class="text-center text-muted"></td>
                <td class="text-center text-muted">
                </td>
                @if(entitySelected?.group=='IASD'){
                @for(i of items?.revenuesDepartaments; track i.departamentFundCode+i.itemCode){                   
                    <th>
                        $  {{((findTotalByDepartament(i?.code)?.totalValue ?? 0))|number:'1.0-0'}}
                    </th>
                    }
                }
                <td class="text-end">
                    @if (items?.revenueTotals?.length > 0) {
                    $ {{ this.getTotalExpense(items?.expenseTotals) | number:'1.0-0' }}
                    }
                </td>
            </tr>
        </tfoot>
    </table>

    <table class="table " id="table-margin">
        <tbody>
            <tr>
                <th class="fw-bold">
                    <h5><i class="fa fa-equals text-primary me-1"></i> Margen (Ingresos - Egresos)</h5>
                </th>
                <th class="fw-bold"> {{findFactorRea(500)?.value}}%</th>
                <th class="fw-bold"> @if (items?.expenseTotals?.length > 0) {
                    {{ ((getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals)) *
                    100 / findTitheTotal()) | number:'1.2-2' }}%
                    }</th>
                    @if(entitySelected?.group=='IASD'){
                    @for(i of items?.revenuesDepartaments; track i.departamentFundCode+i.itemCode){                   
                        <th>
                            $  {{((i?.totalValue-(findTotalByDepartament(i?.code)?.totalValue ?? 0)))|number:'1.0-0'}}
                        </th>
                        }
                    }
                <th class="fw-bold"> @if (items?.revenueTotals?.length > 0) {
                    $ {{ getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals) |
                    number:'1.0-0' }}
                    }</th>


            </tr>
        </tbody>
    </table>
</div>
}

@if(entitySelected?.group!='IASD'){
    <div class="hide">
        <table class="table " id="table-revenue">
            <thead>
                <tr>
                    <th colspan="6">
                        <h5><i class="fa fa-arrow-up text-success me-1"></i> Ingresos por Categoría</h5>
                    </th>
                </tr>
                <tr>
                    <th style="width: 380px;">Descripción</th>
                    <th>% REA</th>
                    <th>% Resultado</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                @for (f of groupedAccounts; track f; let i = $index) {
                <tr>
                    <td>{{ f?.accountParentCode }} - {{ capitalize(f?.accountParentName) }}</td>
                    <td class="text-center text-muted">
    
                    </td>
                    <td class="text-center text-muted">
                        {{ f?.percent | number:'1.2-2' }} %
                    </td>
                    <td class="text-end fw-bold" [ngClass]="{ 'text-danger': f?.totalValue < 0 }">
                        $ {{ f?.totalValue | number:'1.0-0' }}
                    </td>
                </tr>
                }
    
            </tbody>
            <tfoot>
                <tr>
                    <td class="fw-bold">
                        Total Ingresos
                    </td>
                    <td class="text-center text-muted"></td>
                    <td class="text-center text-muted">
                        @if (items?.revenueTotals?.length > 0) {
                        {{ ((getTotalRevenue(items?.revenueTotals)) * 100 /
                        getTotalRevenue(items?.revenueTotals)) | number:'1.0-0' }}%
                        }
                    </td>
                    <td class="text-end">
                        @if (items?.revenueTotals?.length > 0) {
                        $ {{ getTotalRevenue(items?.revenueTotals) | number:'1.0-0' }}
                        }
                    </td>
                </tr>
            </tfoot>
        </table>
    
    
        <table class="table " id="table-expense">
            <thead>
                <tr>
                    <th colspan="6" style="width: 380px;">
                        <h5><i class="fa fa-arrow-down text-danger me-1"></i> Egresos por Categoría</h5>
                    </th>
    
                </tr>
            </thead>
            <tbody>
                @for (f of groupedExpenses; track f; let i = $index){
                <tr>
                    <td>{{f?.code*10000}} - {{capitalize(f?.displayName)}}</td>
                    <td class="text-center text-muted">{{findFactorRea(f?.code)?.value | number:'1.2-2'}} % </td>
                    <td class="text-center text-muted">{{f?.percent | number:'1.2-2'}} % </td>
                    <td class="text-end fw-bold" [ngClass]="{'text-danger': f?.totalValue < 0}">$
                        {{f?.totalValue | number:'1.0-0'}}</td>
                </tr>
                }
    
            </tbody>
            <tfoot>
                <tr>
                    <td class="fw-bold">
                        Total Egresos
                    </td>
                    <td class="text-center text-muted"></td>
                    <td class="text-center text-muted">
                        @if (items?.expenseTotals?.length > 0) {
                        {{ ((this.getTotalExpense(items?.expenseTotals)) * 100 /
                        this.getTotalRevenue(items?.revenueTotals)) | number:'1.2-2' }}%
                        }
                    </td>
                    <td class="text-end">
                        @if (items?.revenueTotals?.length > 0) {
                        $ {{ this.getTotalExpense(items?.expenseTotals) | number:'1.0-0' }}
                        }
                    </td>
                </tr>
            </tfoot>
        </table>
    
        <table class="table " id="table-margin">
            <tbody>
                <tr>
                    <th class="fw-bold">
                        <h5><i class="fa fa-equals text-primary me-1"></i> Margen (Ingresos - Egresos)</h5>
                    </th>
                    <th class="fw-bold"> {{findFactorRea(500)?.value}}%</th>
                    <th class="fw-bold"> @if (items?.expenseTotals?.length > 0) {
                        {{ ((getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals)) *
                        100 / getTotalRevenue(items?.revenueTotals)) | number:'1.2-2' }}%
                        }</th>
                    <th class="fw-bold"> @if (items?.revenueTotals?.length > 0) {
                        $ {{ getTotalRevenue(items?.revenueTotals) - getTotalExpense(items?.expenseTotals) |
                        number:'1.0-0' }}
                        }</th>
    
    
                </tr>
            </tbody>
        </table>
    </div>
    }






  <!--modal diverse-->

  <ng-template #preview let-c="close" let-d="dismiss" let-modal>

    <div class="modal-header">
         <a [href]="pdfSrc" class="btn btn-success btn-sm" target="_blank">Abrir en nueva pestaña</a>
        <span (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="8">
        </span>
    </div>
    <div class="modal-body">
        <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="600px"></iframe>
    </div>

</ng-template>
<!--end diverse-->